import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Level from './Level';
import { ContainerS1 } from './styles';

const Step1 = ({ levelValue = '', device }) => {
  const { t } = useTranslation();

  return (
    <ContainerS1 device={device}>
      <div className='title'>{t('panel.avisos.reputationLevelModal.step1.title')}</div>
      <Level level={levelValue} />
      <p>{t(`panel.avisos.reputationLevelModal.step1.text.${levelValue === 5 ? 'high' : 'low'}`)}</p>
    </ContainerS1>
  );
};

Step1.propTypes = {
  device: PropTypes.string.isRequired
};

export default Step1;
